import { VisibleCards } from 'spw-programming-projects/reports/exportables/hooks';
import { camelCase } from 'lodash';
import { ScreenshotOpts } from 'spw-redux/modules/reports/types';

export const setAllValuesToFalse = (
  visibleCards: Record<string, any>
): Record<string, any> => {
  return Object.keys(visibleCards).reduce(
    (newVisibleCards, key: keyof typeof visibleCards) => {
      if (typeof visibleCards[key] === 'object') {
        return {
          ...newVisibleCards,
          [key]: setAllValuesToFalse(visibleCards[key]),
        };
      }
      return { ...newVisibleCards, [key]: false };
    },
    {}
  );
};

export const updateCategoryCadsVisibility = (
  visibleCards: Record<string, any>,
  category: string,
  key: string
) => {
  const newVisibleCards = setAllValuesToFalse(visibleCards) as VisibleCards;

  const categoryUsfAndSeatMix = newVisibleCards.categoryUsfAndSeatMix[category];

  return {
    ...newVisibleCards,
    categoryUsfAndSeatMix: {
      ...newVisibleCards.categoryUsfAndSeatMix,
      [category]: {
        ...categoryUsfAndSeatMix,
        [key]: true,
      },
    },
  };
};

export const categoryCardPageActions = (category: string, cardType: string) => {
  const selector = camelCase(`${category}_${cardType}`);

  const actions = [
    { action: 'CLICK', selector: '#show-cards' },
    { action: 'CLICK', selector: `#${selector}` },
  ];
  if (
    ['usfAndSeatMix', 'usfMixAndRatios', 'usfMixSeatMixAndSubtotals'].includes(
      cardType
    )
  ) {
    actions.push({
      action: 'WAIT_FOR_HIDDEN_STATE',
      selector: '.MuiList-root',
    });
  }
  return actions;
};

export const categoryCardScreenshotOptions = (
  format: string,
  category: string,
  cardType: string,
  width: number
) => {
  return {
    format,
    exportable: camelCase(`${category}_${cardType}`),
    width: 1440,
    clip: {
      x: 0,
      y: 0,
      width,
    },
    pageActions: categoryCardPageActions(category, cardType),
  } as ScreenshotOpts;
};
